import Apis from '@/Apis/_'
import EventBus from '@/plugins/EventBus'
import Vue from 'vue'

interface MedicoProps {
  id: string
  nome: string
  medicoTemUsuario: boolean
  conselhoTipo: string
  conselhoNumero: string
  conselhoUf: string
  recebeEmailNotificacao: boolean
}

type RequestOptionsProps = {
  showLoading?: boolean
  forceRefresh?: boolean
}

class MedicoStore {
  private fetchedMedicosByInstrumentador = false
  private fetchedMedicosByCurrentUser = false
  public medicosByInstrumentador: MedicoProps[] = []
  public medicosByCurrentUser: MedicoProps[] = []

  setMedicosByInstrumentador(data: MedicoProps[]) {
    this.medicosByInstrumentador = data
  }

  setMedicosByCurrentUser(data: MedicoProps[]) {
    this.medicosByCurrentUser = data
  }

  showLoading() {
    EventBus.$emit('setLoadingRequest', {
      status: true,
      text: 'Carregando...',
    })
  }

  closeLoading() {
    EventBus.$emit('clearLoadingRequest')
  }

  async loadMedicosByInstrumentador({
    showLoading = true,
    forceRefresh = false,
  }: RequestOptionsProps = {}) {
    if (this.fetchedMedicosByInstrumentador && !forceRefresh) return
    if (showLoading) this.showLoading()
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.getAllMedicoByInstrumentadorId()
    if (response.success) {
      this.setMedicosByInstrumentador(response.data)
      this.fetchedMedicosByInstrumentador = true
    } else {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Ocorreu um erro na requisição.',
        icon: 'warning',
        color: '#C62828',
      })
    }
    this.closeLoading()
  }

  async loadMedicosByCurrentUser({
    showLoading = true,
    forceRefresh = false,
  }: RequestOptionsProps = {}) {
    if (this.fetchedMedicosByCurrentUser && !forceRefresh) return
    if (showLoading) this.showLoading()
    const response = await Apis.Agendamento.SolicitacaoCirurgiaApi.getMedicoshospitalByUserCurrent()
    if (response.success) {
      this.setMedicosByCurrentUser(response.data)
      this.fetchedMedicosByCurrentUser = true
    } else {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Ocorreu um erro na requisição.',
        icon: 'warning',
        color: '#C62828',
      })
    }
    this.closeLoading()
  }
}

// Torna a instância reativa
// eslint-disable-next-line import/prefer-default-export
export const medicoStore = Vue.observable(new MedicoStore())
